import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Contracts',
    data () {
        return {
            admin:{},
            contracts: {},
            contract: {},
            panelFlag: false,
            viewFlag: false,
            viewDiscussion: false,
            viewComplaints: false
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.viewDiscussion = false;
                this.viewComplaints = false;
                //this.contract = attr2;
                this.getContract(attr2);
            }
            if(attr == "viewDiscussion"){
                this.viewFlag = false;
                this.viewDiscussion = true;
                this.viewComplaints = false;
            }
            if(attr == "viewComplaints"){
                this.viewFlag = false;
                this.viewDiscussion = false;
                this.viewComplaints = true;
            }
            
        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getContracts() {
            service.getContracts(this).then(data => {
               if(data.body.status == 200) {
                    this.contracts = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        //get Single contracy
        getContract(id) {
            service.getContract(this, id).then(data => {
                if(data.body.status == 200) {
                     this.contract = data.body.data;
                 }
             }).catch((err) => {
                 if(err) {
                     toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
         },

        //get all saved listing
        getMoney(id) {
           service.getMoney(this, id).then(data => {
               if(data.body.status == 200) {
                    this.money = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        endContract() {
            let navi = this.$router;
            service.endContract(this, this.contract.contract_id, this.contract).then(data => {
                if(data.body.status == 200) {
                    toastr.success("Contract Ended!", "Success!");
                    location.reload(); //change later
                }else {
                    toastr.error('Sorry, could not end contract', 'Warning!');
                }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
            })
           
        },
     
    },
    created: function(){
        this.preset();
        this.getContracts();
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/script.js